import React from 'react';
import { CheckIcon, PackageCheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { CtaButton } from './ui/CtaButton';
import { TOMOS, TOMO_INCLUDES } from '../data/content';
export function ProductBreakdown() {
  return <section id="producto" className="bg-canvas py-14" data-id="element-196" data-mp="2whw7wtniuhr8">
      <div className="mx-auto max-w-page px-5" data-id="element-197" data-mp="2ro1prunkeau9">
        <SectionHeading eyebrow="Todo resuelto" title={<>
              PROTOCOLO ENERGÍA REAL™
              <span className="mt-1 block text-[20px] font-bold text-teal-600 sm:text-[24px]" data-id="element-199" data-mp="36ftvrg1gycjb">
                4 Tomos + 3 Bonos
              </span>
            </>} subtitle="Un sistema completo, en PDF, que podés leer en el celular o imprimir. Cada tomo resuelve una parte concreta del cansancio." data-id="element-198" data-mp="2rn9s8eaeq31c" />

        <ol className="mt-9 flex flex-col gap-4" data-id="element-200" data-mp="3adrm4m6z74oa">
          {TOMOS.map(tomo => <li key={tomo.number} className="relative overflow-hidden rounded-2xl border border-line bg-paper p-5 shadow-card" data-id="element-201" data-mp="1l1657kib482d">
              <div className="flex items-start gap-4" data-id="element-202" data-mp="1g3xl3edlltyh">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-night font-display text-[17px] font-black text-amber" data-id="element-203" data-mp="3j7k7p9dqf0c6">
                  {tomo.number}
                </span>
                <div className="min-w-0" data-id="element-204" data-mp="3t2ue09b5xtvr">
                  <p className="text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-flame" data-id="element-205" data-mp="1prdab3on0we">
                    Tomo {Number(tomo.number)} · {tomo.subtitle}
                  </p>
                  <h3 className="mt-1 font-display text-[20px] font-black leading-tight text-night sm:text-[23px]" data-id="element-206" data-mp="5tpd6o0u0fqi">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <p className="mt-3 text-[14.5px] leading-relaxed text-muted" data-id="element-207" data-mp="kobzboqpvg36">{tomo.description}</p>
              <p className="mt-4 flex items-start gap-2 rounded-xl bg-teal-50 px-3.5 py-3 text-[13px] font-bold leading-snug text-teal-700" data-id="element-208" data-mp="2hh5ee2ayzs1l">
                <PackageCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-600" aria-hidden="true" data-id="element-209" data-mp="2mgrr8amvz69v" />
                Te llevás: {tomo.deliverable}
              </p>
            </li>)}
        </ol>

        <div className="mt-6 rounded-2xl border-2 border-dashed border-teal-100 bg-paper p-5" data-id="element-210" data-mp="29hhjp28ezp6y">
          <h3 className="font-display text-[17px] font-black text-night" data-id="element-211" data-mp="2oei4els6ujvx">Cada tomo incluye</h3>
          <ul className="mt-3 flex flex-col gap-2.5" data-id="element-212" data-mp="2jdc5g67xq0dy">
            {TOMO_INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] leading-snug text-night" data-id="element-213" data-mp="2xdmwb998vez4">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flame" aria-hidden="true" data-id="element-214" data-mp="2sftv6umstb5p" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-8" data-id="element-215" data-mp="375sp2l7bm0fd">
          <CtaButton data-id="element-216" data-mp="324lham56h18p" />
        </div>
      </div>
    </section>;
}